
import { BookOpen, Clock, ThumbsUp, LucideIcon } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

export type PainPoint = {
  icon: LucideIcon;
  title: string;
  description: string;
  iconColor?: string;
  bgColor?: string;
  borderColor?: string;
};

export interface PainPointsProps {
  title: React.ReactNode;
  description: string;
  painPoints: PainPoint[];
  className?: string;
}

const BeginnerPainPoints = ({
  title,
  description,
  painPoints,
  className = "",
}: PainPointsProps) => {
  return (
    <section className={`py-20 px-4 bg-white ${className}`}>
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-5xl font-bold mb-6">
            {title}
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            {description}
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {painPoints.map((point, index) => {
            const Icon = point.icon;
            return (
              <Card key={index} className={point.borderColor ? `border-${point.borderColor} ${point.bgColor || "bg-red-50"}` : "border-red-200 bg-red-50"}>
                <CardContent className="p-8">
                  <div className={`bg-white rounded-full w-14 h-14 flex items-center justify-center shadow-sm mb-6 ${point.borderColor ? `border border-${point.borderColor}` : "border border-red-200"}`}>
                    <Icon className={`h-6 w-6 ${point.iconColor || "text-red-500"}`} />
                  </div>
                  <h3 className="text-2xl font-bold mb-4">{point.title}</h3>
                  <p className="text-muted-foreground">
                    {point.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default BeginnerPainPoints;
